import api from "../helpers/axios";

class PromptService {


    async createPrompts(prompt) {
        try {
            const createdPrompt = await api.post(`/prompts/`, prompt);
            return createdPrompt;
        } catch (error) {
            console.log("Error createPrompts: ", error);
        }
    }

    /*
    Get a single prompt's details by its ID (UUID).
    */
    async getPromptById(promptId) {
        try {
            const response = await api.get(`/prompts/${promptId}`);
            return response?.data;
        } catch (error) {
            console.error(`Error fetching prompt with ID ${promptId}:`, error);
            throw error;
        }
    }

    async getAllPrompts(queryParams = "") {
        try {
            const response = await api.get(`/prompts/?platform=admin${queryParams}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching prompts:`, error);
            throw error;
        }
    }

    async updatePrompt(promptId, promptData) {
        try {
            const response = await api.put(`/prompts/${promptId}`, promptData);
            return response.data;
        } catch (error) {
            console.error(`Error updating prompt with ID ${promptId}:`, error);
            throw error;
        }
    }

    async deletePrompt(promptId) {
        try {
            const response = await api.delete(`/prompts/${promptId}`);
            return true;
        } catch (error) {
            console.error(`Error deleting prompt with ID ${promptId}:`, error);
            throw error;
        }
    }


    async getPromptFacilityAccessList(promptId) {
        try {
            const response = await api.get(`/prompts/facility_access_list/${promptId}`);
            return response;
        } catch (error) {
            console.error(`Error fetching prompts:`, error);
            throw error;
        }
    }

    async updatePromptAccess(promptId, payload) {
        try {
            const response = await api.put(`/prompts/facility_access/${promptId}`, payload);
            return response.data;
        } catch (error) {
            console.error(`Error updating prompt with ID ${promptId}:`, error);
            throw error;
        }
    }


    async regeneratePrompt(payload) {
        try {
            const regeneratePrompt = await api.post(`/inference/regenerate_prompt`, payload);
            return regeneratePrompt;
        } catch (error) {
            console.log("Error regeneratePrompt: ", error);
            throw error;
        }
    }

}

export default new PromptService();